const generateForm01 = [
  {
    label: "สาเหตุการลา",
    name: "reason",
    placeholder: "",
    type: "textarea",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ผู้มอบหมายงานแทน",
    name: "delegator",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 9 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "เบอร์โทร",
    name: "delegator_phone",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ระหว่างลาสามารถติดต่อได้ที่",
    name: "address",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "leave_type",
    style: {},
    responsive: { sm: 12, md: 12, lg: 9 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },

  {
    label: "จังหวัด",
    name: "province",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "เขต/อำเภอ",
    name: "district",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "แขวง/ตำบล",
    name: "district_sub",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "รหัสไปรษณีย์",
    name: "postcode",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "เบอร์โทร",
    name: "during_leave_phone",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
];

export default generateForm01;
